import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: localStorage,
    storageKey: 'papersedge-auth',
    // Prevent automatic session refresh on focus
    // Session will still refresh when needed for API calls
    // This helps prevent unnecessary reloads when switching tabs
    flowType: 'pkce',
    // Add these options to help with header size issues
    debug: import.meta.env.DEV,
    // Reduce the amount of data stored in the session
    sessionOptions: {
      // Only store essential session data
      storeSession: true,
      // Don't store user metadata in the session
      storeUserMetadata: false
    }
  }
})